import type { Configuration } from '../../../types/Configuration';

const getThemeVertical = (
  config: Pick<Configuration, 'enableCanvasExperimentalTheme' | 'partnerType' | 'labsPartnerType'>,
) => (config?.enableCanvasExperimentalTheme ? config?.labsPartnerType?.toString() : config?.partnerType?.toString());

export default getThemeVertical;
